<div class="py-8 lg:py-0 p-6 container space-y-12 mx-auto relative">
    <div class="grid grid-cols-12 justify-center gap-4" data-aos="fade-up"  data-aos-delay="400">
        <div class="col-span-12 md:col-span-12">
            <div class="relative text-center">
                <img src="assets/landing-new/icons/star-md.svg" class="hidden xl:block xl:absolute animate-blink top-32 left-0 w-10 h-10" alt="">
                <h2 class="text__grey--gradient text-4xl sm:text-5xl md:text-7xl lg:text-8xl xl:text-9xl mi--font-regular">Partners</h2>
                <p class="text-white text-center text-xl sm:text-2xl lg:text-3xl xl:text-4xl mi--font-regular absolute bottom-0 inset-x-8 lg:inset-x-20">Our Partners</p>
                <img src="assets/landing-new/icons/star-md.svg" class="hidden xl:block xl:absolute animate-blink bottom-32 right-8 w-10 h-10" alt="">
            </div>
        </div>
    </div>
    <div class="grid grid-cols-12 gap-4 items-center justify-center xl:gap-12 pt-6">
        <div class="col-span-6 md:col-span-3">
            <div class="img-hover-zoom--colorize">
              <a href="https://www.blockchainx.tech/" target="_blank">
                <img src="assets/landing-new/images/partners/bx.png" class="w-full h-full p-2 sm:p-4" alt="">
                </a>
            </div>
        </div>
        <div class="col-span-6 md:col-span-3">
            <div class="img-hover-zoom--colorize">
              <a href="https://www.cyphershield.tech/" target="_blank">
                <img src="assets/landing-new/images/partners/cyper-shield.svg" class="w-full h-full p-2 sm:p-4" alt="">
              </a>
            </div>

        </div>
        <div class="col-span-6 md:col-span-3">
            <div class="img-hover-zoom--colorize">
                <a tooltipClass="tooltip-truncate" tooltip="Coming Soon" placement="bottom">
                    <img src="assets/landing-new/images/partners/certik.svg" class="w-full h-full p-2 sm:p-4" alt="">
                </a>
            </div>
        </div>
        <div class="col-span-6 md:col-span-3">
            <div class="img-hover-zoom--colorize">
                <a href="https://dconn.io/" target="_blank"><img src="assets/landing-new/images/partners/dcon.svg" class="w-full h-full p-2 sm:p-4" alt=""></a>
            </div>
        </div>
    </div>
</div>
